import { createContext, useContext, useState, useCallback } from "react";
import { translations } from "@/i18n/translations";

const LanguageContext = createContext(null);

export function LanguageProvider({ children }) {
  const [lang, setLangState] = useState(() => {
    const saved = localStorage.getItem("bzl_lang");
    return ["EN", "FR", "PT"].includes(saved) ? saved : "EN";
  });

  const setLang = useCallback((l) => {
    setLangState(l);
    localStorage.setItem("bzl_lang", l);
    document.documentElement.lang = l.toLowerCase();
  }, []);

  const t = translations[lang];

  return (
    <LanguageContext.Provider value={{ lang, setLang, t }}>
      {children}
    </LanguageContext.Provider>
  );
}

export const useLang = () => useContext(LanguageContext);
